import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from 'store';
import { BlogGeneratorForm } from '../components/GetStarted/BlogGeneratorForm';
import { WelcomeHero } from '../components/GetStarted/WelcomeHero';
import { BlogCard } from '../components/GetStarted/BlogCard';
import Questions from 'features/bot-builder/components/Common/Questions';
import blogService, { allBlogResponse } from '../services/blogApi';
import CardSkeleton from '../components/Skeletons/CardSkeleton';
import { Button } from 'components/ui/button';
import { Apps } from 'constants/global';

export default function GetStartedPage() {
  const [blogInspirations, setBlogInspirations] = useState<allBlogResponse[]>(
    []
  );
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const getUserBlogs = async () => {
      setLoading(true);
      try {
        const response = await blogService.getAllBlogs();

        setBlogInspirations(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    getUserBlogs();
  }, []);

  return (
    <div className="bg-background-main dark:bg-background min-h-[800px] justify-center items-center">
      <div className="bg-gradient-light dark:bg-gradient-dark bg-no-repeat bg-cover rounded-lg rounded-b-none border border-background-main min-h-[640px] pb-16">
        <div className="mx-auto py-14 flex flex-col justify-center items-center lg:px-11 max-w-7xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-12">
            <WelcomeHero />
            <BlogGeneratorForm />
          </div>
        </div>
      </div>

      {isAuthenticated ? (
        <div className="mx-auto rounded-lg rounded-t-none  p-16 max-w-7xl">
          <div className="flex flex-col lg:flex-row justify-center items-center pb-4 lg:pb-0 lg:justify-between ">
            <h2 className="text-[30px] text-text-primary font-bold mb-6">
              Your Blogs
            </h2>
            <Link to="/ai-blog-writer/history">
              <Button
                variant="customSecondary"
                className=" text-sm bg-secondary px-8"
              >
                Show all
              </Button>
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogInspirations.length === 0 ? (
              loading ? (
                'Please wait'
              ) : (
                <>
                  <CardSkeleton />
                  <CardSkeleton />
                  <CardSkeleton />
                </>
              )
            ) : (
              blogInspirations.map((blog) => (
                <Link to={`/ai-blog-writer/blog?id=${blog.id}`} key={blog.id}>
                  <BlogCard
                    title={blog?.title}
                    date={blog?.created_at}
                    image={blog?.cover_img_url || '/test.png'}
                  />
                </Link>
              ))
            )}
          </div>
        </div>
      ) : (
        <></>
      )}

      <Questions appType={Apps.BLOG_WRITER} />
    </div>
  );
}
